import React from "react"
import { values, get, keys, findIndex } from "lodash"
import { Panel, Row, Modal, Col } from "react-bootstrap"
import Ajax from "superagent"
import styled from "styled-components"
import JsonView from "react-json-view"
import { Link } from "react-router-dom"

import Button from "../components/Button"
import data from "../../../../data"
import { reservationName } from "./tables/table.aux"

const PageWrapper = styled.div`
  max-width: 720px;
  @media (min-width: 600px) {
    margin-left: 10vw;
    margin-right: 10vw;
    padding-top: 20px;
  }
  @media (max-width: 600px) {
    margin-left: 10px;
    margin-right: 10px;
    paddingTop: 10px;
  }
`

const Code = styled.div`
  font-family: monospace;
  color: #333;
`
const ProductType = {
  restaurant: "Restaurante",
  table: "Restaurante",
  ticket: "Entrada",
  onedaytrip: "OneDay Trip",
  car: "Transporte"
}

const SMS = ({ label, text, phone }) => (
  <Panel
    header={(
      <div>
        {label}
        <a href={`sms:${phone}&body=${text}`} style={{float: "right"}}>
          <Button glyph="send" style={{marginRight: 10}}>
            Enviar
          </Button>
        </a>
      </div>
    )}
  >
    {text}
  </Panel>
)

const mailLink = (restaurant, reservation) => {
  const body = (
    `Buenos días; hemos recibido una solicitud de reserva de un cliente para vuestro restaurante:

  - Cliente: ${get(reservation, "name", "ERROR: NO NAME")}
  - Día: ${get(reservation, "day", "ERROR: NO DAY")}
  - Hora: ${get(reservation, "shift", "ERROR: NO SHIFT")}

Ya tienen elegido su pedido, y ya nos lo han pagado a nosotros:

${
    (
      reservation.menus ? reservation.menus : []
    ).map(menu => (
      ` - ${menu.count} x ${restaurant.menus[menu.menu].name} (${restaurant.drinks[menu.drink].name})`
    )).join("\n")
    }
${
    (
      reservation.carta ? values(reservation.carta) : []
    ).map(plato => (
      ` - ${plato.count} x ${restaurant.carta.dishes[plato.id].name}`
    )).join("\n")
    }
${
    (
      reservation.drinks ? values(reservation.drinks) : []
    ).map(drink => (
      ` - ${drink.count} x ${restaurant.drinks[drink.id].name}`
    ))
    }

Si tenéis cualquier duda, por favor llamadnos al 655218426 (Antonella). Nosotros en cualquier caso os llamaremos para confirmar.

Muchas gracias y un saludo,

Chinespain
`
  )

  return (
    `mailto:${restaurant.reservationMail || "jesusiniesta03@gmail.com"}`
    + "?subject=Reserva ChineSpain&"
    + "cc=ventas@chinespain.com&"
    + `body=${encodeURIComponent(body)}`
  )
}

const RestaurantInfo = ({ restaurant, reservation }) => (
  <Panel header="Info restaurante">
    {
      restaurant.reservationNote
        ? (<p>{restaurant.reservationNote}</p>)
        : (<p><i>No hay nota</i></p>)
    }
    {
      restaurant.reservationPhone ? (
        <a href={`tel:${restaurant.reservationPhone}`}>
          <Button glyph="phone-alt" style={{marginRight: 10}}>
            Llamar
          </Button>
        </a>
      ) : (
        <Button glyph="phone-alt" disabled style={{marginRight: 10}}>
          Llamar
        </Button>
      )
    }
    {
      restaurant.reservationMail ? (
        <a href={mailLink(restaurant, reservation)}>
          <Button glyph="pencil">Enviar mail</Button>
        </a>
      ) : (
        <Button glyph="pencil" disabled>
          Enviar mail
        </Button>
      )
    }
  </Panel>
)

const Layout = ({ left, right, bottom }) => (
  <PageWrapper>
    <Row>
      <Col md={6} sm={12}>
        {left}
      </Col>
      <Col md={6} sm={12}>
        {right}
      </Col>
    </Row>
    {bottom}
  </PageWrapper>
)

/**
 *
 */

class ReservationDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    Ajax
      .get(`/getreservation?id=${this.props.match.params.id}`)
      .then(res => {
        this.setState({reservation: res.body})
      })
  }

  firstSMS() {
    const r = this.state.reservation
    return (
      `您好，${r.name || ""}。我们已经收到您的预定信息，非常感谢您的配合！接下来我们会尽快和餐厅确认您的预定。`
      // `Hola ${r.name}, hemos recibido tu reserva. Muchas gracias! `
      // + `Vamos a confirmar con el restaurante.`
    )
  }

  secondSMS() {
    const r = this.state.reservation
    const rr = r.product || {}
    return (
      `${rr.name || ""}餐厅已经接受您的就餐预定！当您抵达餐厅前台时，请出示下面链接所显示的页面，餐厅将会热情接待您。`
      // `Tu reserva en ${rr.name} ha sido confirmada! Cuando llegues allí, `
      // + `enseña esta página y sabrán como mimarte ;)`
      + "\n  "
      + `https://zhangshangxby.com/catalogo/resume/${r._id}`
    )
  }

  render() {

    if (!this.state.reservation) return (
      <span>
        Cargando
      </span>
    )
    else {
      console.log(this.state)
      const r = this.state.reservation
      const product = r.product || {}
      const destination = data[r.destinationZone]
        ? get(data, [r.destinationZone, r.destinationPlace, "name"], `${r.destinationZone} > ${r.destinationPlace}`)
        : (
          get(data.cities, [r.city, "locations", r.destinationZone], []).find(x => (x.value == r.destinationPlace))
          || {}
        ).label

      return (
        <div>
          {
            this.state.jsonModal && (
              <Modal show onHide={() => this.setState({ jsonModal: false })}>
                <Modal.Header onHide={() => this.setState({ jsonModal: false })}>
                  <Modal.Title>Detalles para frikis</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <JsonView src={{ state: this.state, product, destination, reservation: r }} />
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={() => this.setState({ jsonModal: false })} label="Cerrar" />
                </Modal.Footer>
              </Modal>
            )
          }
          <PageWrapper>
            <Link to="/private" style={{fontWeight: "bold", fontSize: "15px"}}>{ `< Volver a las reservas`}</Link>
            <h2>{reservationName(r)} para {r.name} ({r.day})</h2>
          </PageWrapper>
          <Layout
            left={(
              <div>
                <ul>
                  <li>Id: <code>{r._id}</code></li>
                  <li>sessionId: <code>{r.sessionId}</code> </li>
                  <li>clientId: <code>{r.clientId}</code></li>
                  <li>timestamp: <code>{r.timestamp}</code></li>
                  <li>
                    <Button
                      bsStyle="link"
                      label="Detalles para frikis"
                      glyph="wrench"
                      onClick={() => this.setState({ jsonModal: true })} />
                  </li>
                </ul>

                <ul>
                  <li>Día: {r.day}</li>

                  {
                    r.shift && (
                      <li>Turno: {r.shift}</li>
                    )
                  }

                  {
                    r.options && keys(r.options).map(optionKey => {
                      const valueKey = r.options[optionKey]
                      const optionValues = product.options[optionKey].values
                      const valueObject = optionValues[findIndex(optionValues, ['key', valueKey])]
                      return (
                        <li key>{product.options[optionKey].title}: {valueObject.chvalue} {valueObject.value && `(${valueObject.value})`}</li>
                      )
                    })
                  }

                  <li>Personas: {r.persons}</li>

                  {
                    r.luggage && (
                      <li>Maletas: {r.luggage}</li>
                    )
                  }

                  <li>Nombre: {r.name}</li>
                  <li>Telefono: {r.prefix} {r.phone}</li>
                  <li>Email: {r.email}</li>
                  <li>Precio: {" "}<b>{Number(r.eurPrice || 0).toFixed(2)}€</b> / {Number(r.yuanPrice || 0).toFixed(2)}¥</li>
                  <li>{ProductType[r.type] || r.type}: {product.name || "N/A"}</li>

                  {r.extras && (
                    <li>
                      Extras:
                      <ol style={{marginLeft: "25px"}}>
                        {keys(r.extras).map(extraKey => <li key={extraKey}>
                          {product.extras[extraKey].chTitle}
                          {product.extras[extraKey].title && ` (${product.extras[extraKey].title})`}
                        </li>)}
                      </ol>
                    </li>
                  )}

                </ul>

                <ul>
                  {r.originAddress && r.originCoords && (<li>Origen: {r.originAddress} ({r.originCoords[0]},{r.originCoords[1]})</li>)}
                  {r.destinationAddress && r.destinationCoords && (<li>Destino: {r.destinationAddress} ({r.destinationCoords[0]},{r.destinationCoords[1]})</li>)}
                  {r.selectedCar && r.selectedCar.display_name && (<li>Tipo coche: {r.selectedCar.display_name}</li>)}
                </ul>

                {
                  r.type == "table" && (
                    <li>Reserva de mesa</li>
                  )
                }

                {
                  r.menus && (
                    <li>
                      Pedido:
                      <ul>
                        {
                          r.menus && r.menus.map((menu, i) => (
                            <li key={menu.key || menu.name || i}>
                              {menu.count} x {menu.name}
                            </li>
                          ))
                        }
                        {
                          r.carta && values(r.carta).map(plato => (
                            <li>{plato.count} x {product.carta.dishes[plato.id].name}</li>
                          ))
                        }
                        {
                          r.drinks && values(r.drinks).map(drink => (
                            <li>{drink.count} x {drink.name}</li>
                          ))
                        }
                      </ul>
                    </li>
                  )
                }

                {r.comment  && (
                  <li>
                    Comentario:
                    <Panel>
                      {r.comment}
                    </Panel>
                  </li>
                )}
              </div>
            )}
            right={(
              <div>
                <RestaurantInfo restaurant={product} reservation={r} />
                <SMS phone={`${r.prefix}${r.phone}`} label="Primer SMS (recibido)" text={this.firstSMS()} />
                <SMS phone={`${r.prefix}${r.phone}`} label="Segundo SMS (confirmado)" text={this.secondSMS()} />
              </div>
            )}
          />

        </div>

      )
    }

  }
}

export default ReservationDetails



// WEBPACK FOOTER //
// ./src/app/admin/components/ReservationDetails.jsx